export enum ItemTypes {
    Page = "page",
    Url = "url",
    Document = "document",
}
